<template>
  <path d="M8 15V5C8 3.61929 6.88071 2.5 5.5 2.5H1.5V12.5H5.75C6.99264 12.5 8 13.5074 8 14.75V15Z"
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
  <path d="M8 15V5C8 3.61929 9.11929 2.5 10.5 2.5H14.5V12.5H10.25C9.00736 12.5 8 13.5074 8 14.75V15Z"
    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
</template>
